import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { useStore } from '../../../../app/stores/store';
import DynamicTableFrontEnd from '../../../DynamicTable/DynamicTableFrontEnd';

function OrderRegisterTable() {
  const { DeliveryStore } = useStore();
  const { orderRegisterTable, listOrderRegister } = DeliveryStore;
  const [showText, setShow] = useState(false);
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    listOrderRegister();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    let newArr: any = [];
    orderRegisterTable.forEach((x) => {
      x.itemDeliveryRequest.forEach((y: any) => {
        newArr.push(y);
      });
    });
    setTableData(newArr);
    // eslint-disable-next-line
  }, [orderRegisterTable]);

  useEffect(() => {
    setShow(true);
  }, [orderRegisterTable]);

  const removeCol =
    'isReceiving,isDelivery,isReceivingOrder,files,assignedUsers,comments,itemHistory,orders,itemDeliveryRequest,inwards,receivings,host,isDeleted,isActive,cast,thumbnail_large,thumbnail_small,groove_type,speed_and_speed_adjustment,number_of_channels_and_sound_channel_map,file_format_name_and_version,analog_media,format_in_terms_of_broadcast_standards,bits_per_sample_and_sampling_description,songs,physcial_format,host,hostUsername,originIndia,itemCreatedAt,inactive,isgoing,ishost';
  const CustomerTable = JSON.parse(JSON.stringify(tableData));
  CustomerTable.map((i: any) => removeCol.split(',').map((j) => delete i[j]));

  return (
    <div>
      {showText && (
        <DynamicTableFrontEnd
          data={CustomerTable}
          name={'OrderRegisterTable'}
          actiontype={''}
        />
      )}
    </div>
  );
}

export default observer(OrderRegisterTable);
